module.exports = __webpack_public_path__ + "static/media/a4intro.01762fb7.jpg";